import FingerprintJS from '@fingerprintjs/fingerprintjs';

export function checkAuthorization () {
	// attempt to grab the token from localstorage
	const storedToken = localStorage.getItem('access_token');
	// if it exists
	return !!storedToken;
}

export function getAuthorization () {
	// attempt to grab the token from localstorage
	const storedToken = localStorage.getItem('access_token');

	// if it exists
	if (storedToken) {
		// parse it down into an object
		return JSON.parse(storedToken)
	}

	return {};
}

export async function getFingerprint()
{
	let salt = localStorage.getItem('oa-z-id');

	if (!salt)
	{
		salt = crypto.randomUUID(); // hoặc dùng random string

		localStorage.setItem('oa-z-id', salt);
	}

	const fp = await FingerprintJS.load();

	const result = await fp.get();

	return result.visitorId + '-id-' + salt; // Đây là fingerprint ID bạn gửi lên server
}